<template>
  <div>
    <!-- Formulário -->
    <div class="alert alert-light" v-if="value.dados == '@'">
      <span v-html="value.st_anamnese"></span>
    </div>
    <div id="anamneseForm" class="alert alert-light" v-else>
      <div v-if="value.doc_certificado_link" class="d-flex flex-column mb-3">
        <a :href="value.doc_certificado_link" class="btn btn-outline-primary" target="_blank">
          <i class="fa fa-print mr-2" aria-hidden="true"></i>
          Documento Assinado
        </a>
      </div>

      <formulario
        v-if="!ehlaudo"
        :compact="value.modelo_prontuario ? value.modelo_prontuario.fl_compact : false"
        :modelo_prontuario="value.modelo_prontuario"
        :gutters="value.modelo_prontuario ? value.modelo_prontuario.fl_espaco_reduzido : false"
        :tamanhoform="value.modelo_prontuario ? value.modelo_prontuario.st_form_tamanho_padrao : ''"
        :validate="validate"
        v-model="value.dados"
        :tipo_consulta="tipo_consulta"
        :modeloPadrao="value.id_modelo_prontuario"
        :saved="saved"
        :padrao_procedimento="( !tipo_consulta && atendimento_procedimento.medico_procedimento_unidade ) ? atendimento_procedimento.medico_procedimento_unidade.id_modelo_prontuario : null"
        :id_procedimento="atendimento_procedimento.id_procedimento"
        :id_atendimento="atendimento_procedimento.id_atendimento"
        :id_atendimento_procedimento="atendimento_procedimento.id_atendimento_procedimento"
        :layout_impressao="value.st_layout_impressao"
        @changeModelo="atualizarModelo"
        @definirModelo="definirModelo"
        @imprimirAnamnese="imprimirAnamnese(value.id_anamnese)"
        :mode="pode_alterar && !value.doc_certificado_link ? 'edit' : 'view'"
        :view_with_print="true"
        :infopaciente="infopaciente">
        <template v-slot:botoes>
          <button type="button" class="btn btn-link btn-sm" data-toggle="tooltip" data-placement="top" title="Assinar"
            @click="assinar({ ...value, model: { type: 'anamnese', id: value.id_anamnese } })"
            :disabled="!saved">
            <i class="fas fa-signature"></i>
          </button>

          <button type="button" class="btn btn-link btn-sm" data-toggle="tooltip" data-placement="top" title="Log"
            @click="$util.logAudit('anamnese', value.id_anamnese)"
            v-if="$store.state.user.id_usuario == 1">
            Log
          </button>
        </template>
      </formulario>

      <div class="text-right" v-if="value.doc_certificado_link && pode_alterar">
        <button class="btn btn-sm btn-link text-danger"
          type="button" @click="cancelar_assinatura()">
          <i class="fa fa-times mr-1" aria-hidden="true"></i>
          Cancelar Assinatura
        </button>
      </div>
    </div>

    <div v-if="( 1 == 1 || tipo_consulta )">

      <div class="d-flex justify-content-end" v-if="lista_complementos(value).length">
        <button type="button" class="btn btn-link" @click="toggle_hide_all(value)">
          <i class="fas fa-compress-arrows-alt"></i>
        </button>
      </div>

      <!-- Receita -->
      <div id="receitas">
        <order-set-view
          :callback_compartilhar="compartilhar_order_set"
          :dados="value.receita"
          :solmatmed="true"
          type="receita"
          @editar="abrir('receita', $event)"
          @imprimir="imprimir_receita"
          @refresh="$emit('refresh')"
          @assinar="assinar"
          :atendimento="atendimento"
          :pep="true"
        />
      </div>

      <!-- Botão Importação de Resultados -->
      <div v-if="eh_consulta(atendimento_procedimento) && ( $store.state.user.id_usuario == 1 ) && mode == 'atendimento' && pode_alterar" class="d-flex flex-column">
        <button type="button" class="btn btn-dark mb-2" @click="abrir_import ()">
          Importar Resultados de Exames
        </button>
      </div>

      <!-- Botão Inclusão de Receita -->
      <div v-if="eh_consulta(atendimento_procedimento) && ( !value.receita || !value.receita.length ) && mode == 'atendimento' && pode_alterar" class="d-flex flex-column">
        <button type="button" class="btn btn-outline-success mb-2" @click="abrir ('receita')">
          <i class="fas fa-prescription mr-2"></i>
          Incluir Receita
        </button>

        <button type="button" class="btn btn-outline-primary mb-2" v-if="tem_prescricao" @click="abrir ('receita', null, true)">
          <i class="fas fa-pills mr-2"></i>
          Incluir Prescrição
        </button>
      </div>

      <!-- Requisição -->
      <order-set-view
        :callback_compartilhar="compartilhar_order_set"
        :dados="value.requisicao"
        type="requisicao"
        @editar="abrir('requisicao', $event, value.requisicao.fl_cirurgia)"
        @imprimir="imprimir_requisicao"
        @refresh="$emit('refresh')"
        @assinar="assinar"
        :atendimento="atendimento"
        :pep="true"
      />

      <div v-if="eh_consulta(atendimento_procedimento) && ( !value.requisicao || !value.requisicao.length ) && mode == 'atendimento' && pode_alterar" class="d-flex flex-column">
        <button type="button" class="btn btn-outline-info mb-2" @click="abrir ('requisicao')">
          <i class="fas fa-heartbeat mr-2"></i>
          Incluir Requisição de Exames/Procedimentos
        </button>

        <button type="button" class="btn btn-outline-info mb-2" @click="abrir ('requisicao', null, true)">
          <i class="fas fa-procedures mr-2"></i>
          Incluir Solicitação de Cirurgia
        </button>
      </div>

      <div v-if="marcacao && marcacao.recepcao && marcacao.recepcao.filas && marcacao.recepcao.filas.length && mode == 'atendimento' && pode_alterar" class="d-flex flex-column">
        <button type="button" class="btn btn-outline-dark mb-2" @click="abrir_fila (fila)"
          v-for="(fila, ifx) in marcacao.recepcao.filas" :key="ifx">
          <i class="fas fa-notes-medical mr-2"></i>
          {{ fila.st_titulo }}
        </button>
      </div>

    </div>

    <!-- Documentos -->

    <div v-if="tags_doc && tags_doc.length" class="text-right mb-1">
      <a href="#" @click.prevent="search_doc == tag ? search_doc = '' : search_doc = tag" v-for="(tag, itx) in tags_doc" :key="itx">
        <span class="badge ml-1" :class="tag == search_doc ? 'badge-success' : 'badge-secondary'">
          {{ tag }}
        </span>
      </a>
    </div>

    <div class="alert alert-light border-warning mb-2" v-for="(doc, idc) in lista_documentos" :key="'doc' + idc">
      <span class="close" title="Log de Alterações">
        <a href="#" class="alert-link mr-1 ml-2" @click.prevent="$util.logAudit('documentoAtendimento', doc.id_documento_atendimento)">
            <i class="fas fa-question-circle"></i>
        </a>
      </span>

      <span class="close" v-if="doc.doc_certificado && doc.doc_certificado_link">
        <a href="#" class="alert-link mr-1 ml-2" @click.prevent="cancelar(doc)">
          <i class="fa fa-times-circle" aria-hidden="true"></i>
        </a>
      </span>
      <span class="close" v-if="doc.doc_certificado && doc.doc_certificado_link">
        <a :href="doc.doc_certificado_link" class="alert-link mr-1 ml-2" target="_blank">
          <i class="fas fa-file-contract"></i>
        </a>
      </span>
      <span class="close" v-else-if="pode_assinar">
        <a href="#" class="alert-link mr-1 ml-2" @click.prevent="assinar(doc)">
          <i class="fas fa-signature"></i>
        </a>
      </span>
      <span class="close">
        <a href="#" @click.prevent="imprimir_documento(doc)" class="alert-link" title="Imprimir">
          <i class="fas fa-print"></i>
        </a>
      </span>
      <span class="close">
        <a class="alert-link mx-2" href="#" @click.prevent="$refs.documento.editar(doc)" title="Editar">
          <i class="far fa-file-alt"></i>
        </a>
      </span>
      <span class="close text-danger small" v-if="doc.removendo">
        <div class="spinner-border spinner-border-sm" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </span>
      <div>
        <div :class="doc.hide ? '' : 'mb-3'">
          <a href="#" @click.prevent="doc.hide = !doc.hide" class="alert-link mr-2" title="Exibição">
            <i class="far fa-minus-square" v-if="!doc.hide"></i>
            <i class="far fa-plus-square" v-else></i>
          </a>
          {{ doc.st_titulo }}
          <span v-if="doc.modelo_documento && doc.modelo_documento.st_nome && doc.modelo_documento.st_nome != doc.st_titulo" class="text-muted">
            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
            {{ doc.modelo_documento.st_nome }}
          </span>
        </div>
        <div v-show="!doc.hide" class="ajusteform">
          <div v-if="doc.fl_formulario">
            <formulario v-model="doc.estrutura" mode="view" />
          </div>
          <div v-else class="encurtar" v-html="doc.texto_html"></div>
        </div>
      </div>
    </div>

    <!-- Atestados -->

    <div v-if="eh_consulta(atendimento_procedimento) && ( !value.atestados || !value.atestados.length ) && mode == 'atendimento' && pode_alterar" class="d-flex flex-column">
        <button type="button" class="btn btn-outline-secondary mb-2" @click="abrir_atestado ()">
          <i class="fas fa-plus mr-2"></i>
          Incluir Atestado
        </button>
      </div>

    <div v-for="(atest, ida) in value.atestados" :key="'atest' + ida">
      <atestado-view :atest="atest"
        :atendimento="atendimento"
        @assinar="assinar"
        @refresh="$emit('refresh')"
        :pep="true" />
    </div>

    <div v-if="prescricao_suspender" class="d-flex flex-column">
        <button type="button" class="btn btn-outline-dark mb-2" @click="prescricoes_ativas ()">
            <i class="fa-solid fa-pills mr-2"></i>
            Prescrições Ativas
        </button>
    </div>

    <!-- Anexos -->

    <template v-if="value.arquivos && value.arquivos.length">

      <div class="alert alert-light d-flex justify-content-between">
        <div v-if="value.arquivos.length">
          <a :href="arq.arquivo.temporary_url" class="text-white"
            v-for="(arq, iax) in value.arquivos" :key="iax" target="_blank">
            <span class="badge badge-primary p-2 mr-2 mb-2">
              <i class="fa fa-paperclip mr-2" aria-hidden="true"></i>
              {{ arq.arquivo.st_titulo }}
            </span>
          </a>
        </div>
        <div>
          <a href="#" @click.prevent="ver_anexos_preview = !ver_anexos_preview">
            <i class="fa-solid fa-eye-slash fa-fw" v-if="!ver_anexos_preview"></i>
            <i class="fa-solid fa-eye fa-fw" v-else></i>
          </a>
        </div>
      </div>

      <template v-if="ver_anexos_preview">

        <ver-arquivos-rolagem :arquivos="value.arquivos" />

        <template v-if="false">

          <div class="card bg-light" v-for="(arq_view, ivx) in value.arquivos" :key="ivx">
            <div class="card-header">
              <a href="#" @click.prevent="arq_view.arquivo.visibility = !arq_view.arquivo.visibility" class="card-link">
                {{ arq_view.arquivo.st_titulo }}
              </a>
            </div>

            <div class="card-body" v-if=" ( arq_view && arq_view.arquivo.visibility )">
              <div :src="arq_view ? arq_view.arquivo.temporary_url : ''" style="width: 100%;height: 100%; border: none;" v-if="arq_view && is_image(arq_view.arquivo)">
                  <viewer :images="[arq_view.arquivo.temporary_url]">
                      <figure class="figure">
                          <img :src="arq_view.arquivo.temporary_url" class="figure-img img-fluid rounded" style="max-height: 100%; max-width: 100%;">
                      </figure>
                  </viewer>
              </div>

              <iframe :src="link_office(arq_view.arquivo)" style="width: 100%;height: 100%; border: none;" v-else-if="arq_view && is_office(arq_view.arquivo)">
                  Oops! ocorreu um erro ao abrir o arquivo.
              </iframe>

              <iframe :src="arq_view.arquivo ? arq_view.arquivo.temporary_url : ''" style="width: 100%;height: 640px; border: none;" v-else>
                  Oops! ocorreu um erro ao abrir o arquivo.
              </iframe>
            </div>
          </div>

        </template>

      </template>

    </template>

    <!-- Menu de Opções -->

    <nav class="navbar fixed-bottom navbar-light bg-light" v-if="atendimento && atendimento.avulso && atendimento.avulso.fl_no_pep">
      <a class="navbar-brand d-none d-lg-block" href="#" @click.prevent>
      </a>
      <div class="mr-3">
        <div class="progress">
          <div class="indeterminate" v-if="$store.state.loading"></div>
          <div class="determinate" v-else></div>
        </div>
        <template v-if="pode_alterar">
          <button class="btn btn-sm btn-outline-danger ml-1" type="button"
            @click="enviar_arquivo ()"
            data-toggle="tooltip" data-placement="top" title="Novo Arquivo Anexo">
            <i class="fas fa-paperclip"></i>
          </button>
        </template>
        <slot></slot>
      </div>
    </nav>

    <nav class="navbar fixed-bottom navbar-light bg-light" v-if="!atendimento || !atendimento.avulso || !atendimento.avulso.fl_no_pep">
      <a class="navbar-brand d-none d-lg-block" href="#" @click.prevent>
        <!-- Galeria de Imagens -->
        <button type="button" class="btn btn-outline-success btn-sm mr-1"
          data-toggle="tooltip" data-placement="top" title="Galeria de Imagens."
          @click="abrir_galeria_imagens()">
          <i class="fas fa-images"></i>
        </button>

        <!-- Resultados -->
        <button type="button" class="btn btn-outline-success btn-sm mr-1"
          data-toggle="tooltip" data-placement="top" title="Resultados de Exames."
          @click="resultados ()">
          <i class="fas fa-table"></i>
        </button>

        <button type="button" class="btn btn-outline-success btn-sm mr-1"
          data-toggle="tooltip" data-placement="top" title="Resultados de Exames na Lateral."
          @click="resultados (true)">
          <i class="fas fa-arrow-circle-right mr-1"></i>
        </button>

      </a>
      <div class="mr-3">
        <div class="progress">
          <div class="indeterminate" v-if="$store.state.loading"></div>
          <div class="determinate" v-else></div>
        </div>
        <template v-if="pode_alterar">
          <button class="btn btn-sm btn-outline-info ml-1" type="button" @click="abrir_ymunity()"
            v-if="integracao_ymunity"
            data-toggle="tooltip" data-placement="top" title="yMunity">
            <i class="fa-solid fa-y"></i>
          </button>
          <button class="btn btn-sm btn-outline-info ml-1" type="button" @click="memed()"
            v-if="atendimento.medico.st_memed_status == 'A'"
            data-toggle="tooltip" data-placement="top" title="Memed">
            <i class="fas fa-medkit"></i>
          </button>
          <url-estudo-pacs
            :id_atendimento_procedimento="atendimento_procedimento.id_atendimento_procedimento"
            :id_paciente="id_paciente">
          </url-estudo-pacs>
          <button class="btn btn-sm btn-outline-danger ml-1" type="button"
            @click="enviar_arquivo ()"
            data-toggle="tooltip" data-placement="top" title="Novo Arquivo Anexo">
            <i class="fas fa-paperclip"></i>
          </button>

          <button class="btn btn-sm btn-outline-secondary ml-1" type="button"
            @click="abrir_atestado ()"
            data-toggle="tooltip" data-placement="top" title="Novo Atestado">
            <i class="fas fa-plus"></i>
          </button>

          <button class="btn btn-sm btn-outline-warning ml-1" type="button"
            @click="$refs.documento.novoDocumento ()"
            data-toggle="tooltip" data-placement="top" title="Novo Documento">
            <i class="far fa-file-alt"></i>
          </button>

          <button class="btn btn-sm btn-outline-info ml-1" type="button"
            @click="abrir ('requisicao')"
            data-toggle="tooltip" data-placement="top" title="Nova Requisição"
            v-if="1 == 1 || tipo_consulta">
            <i class="fas fa-heartbeat"></i>
          </button>

          <button class="btn btn-sm btn-outline-info ml-1" type="button"
            @click="abrir ('requisicao', null, true)"
            data-toggle="tooltip" data-placement="top" title="Nova Solicitação de Cirurgia">
            <i class="fas fa-procedures"></i>
          </button>

          <button class="btn btn-sm btn-outline-info ml-1" type="button"
            @click="abrir ('requisicao', null, false, 'C')" v-if="tem_solic_consulta"
            data-toggle="tooltip" data-placement="top" title="Nova Solicitação de Encaminhamento de Consulta">
            <i class="fas fa-stethoscope"></i>
          </button>

          <button class="btn btn-sm btn-outline-success ml-1" type="button"
            @click="abrir ('receita')"
            data-toggle="tooltip" data-placement="top" title="Nova Receita" v-if="1 == 1 || tipo_consulta">
            <i class="fas fa-prescription"></i>
          </button>

          <button class="btn btn-sm btn-outline-primary ml-1" type="button" @click="abrir ('receita', null, true)"
            data-toggle="tooltip" data-placement="top" title="Nova Prescrição" v-if="tem_prescricao">
            <i class="fas fa-pills"></i>
          </button>

          <button class="btn btn-sm btn-outline-primary ml-1" type="button" @click="abrir ('infusao', null, true)"
            data-toggle="tooltip" data-placement="top" title="Prescrição de Infusão" v-if="false && tem_infusao">
            <i class="fas fa-syringe"></i>
          </button>

          <div class="btn-group dropup ml-2" v-if="lista_fixa_barra(atendimento_procedimento).length">
            <button class="btn btn-sm btn-outline-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <i class="fas fa-plus-circle"></i>
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
              <a class="dropdown-item" href="#" @click.prevent="novo_documento (form.id_modelo_prontuario)"
                v-for="(form, iform) in lista_fixa_barra(atendimento_procedimento)" :key="iform"
                :title="form.st_modelo_prontuario">
                <span class="d-block d-lg-none">
                  <i class="fas fa-plus-circle mr-2"></i>
                  {{ form.initials }}
                </span>
                <span class="d-none d-lg-block">
                  <i class="fas fa-plus-circle mr-2"></i>
                  {{ form.st_modelo_prontuario }}
                </span>
              </a>
            </div>
          </div>

          <template v-if="false">
            <button
              class="btn btn-sm btn-outline-primary ml-1"
              type="button"
              @click="novo_documento (form.id_modelo_prontuario)"
              data-toggle="tooltip"
              data-placement="top"
              :title="form.st_modelo_prontuario"
              v-for="(form, iform) in lista_fixa_barra(atendimento_procedimento)"
              :key="iform"
            >
              <span class="d-block d-lg-none">
                <i class="fas fa-plus-circle"></i>
                {{ form.initials }}
              </span>
              <span class="d-none d-lg-block">
                <i class="fas fa-plus-circle"></i>
                {{ form.st_modelo_prontuario }}
              </span>
            </button>
          </template>

        </template>
        <slot></slot>
      </div>
    </nav>

    <!-- Prescrição -->
    <order-set
      :title="( receita && receita.fl_prescricao ) ? 'Prescrição' : 'Receita'"
      v-model="receita"
      service="medicamentos.index"
      name="receita"
      ref="receita"
      :id_anamnese="value.id_anamnese"
      :id_paciente="id_paciente"
      :id_unidade_operacao="( atendimento && atendimento.marcacao ) 
        ? atendimento.marcacao.id_unidade_operacao 
        : ( atendimento.avulso ? atendimento.avulso.id_unidade_operacao : null )"
      :atendimento="atendimento"
      :tem_infusao="tem_infusao"
      :receita_medicamento_buscar="receita_medicamento_buscar"
      @refresh="imprimir_receita"
      @validar_ativas="prescricoes_ativas"
    ></order-set>

    <!-- Requisição -->
    <order-set
      :title="title_requisicao"
      v-model="requisicao"
      service="procedimentos.index"
      name="requisicao"
      ref="requisicao"
      :cirurgia="false"
      :id_anamnese="value.id_anamnese"
      :id_paciente="id_paciente"
      :id_unidade_operacao="( atendimento && atendimento.marcacao ) 
        ? atendimento.marcacao.id_unidade_operacao 
        : ( atendimento.avulso ? atendimento.avulso.id_unidade_operacao : null )"
      :atendimento="atendimento"
      @refresh="imprimir_requisicao"
    ></order-set>

    <!-- Cirurgia -->
    <order-set
      title="Encaminhamento de Consulta"
      v-model="requisicao"
      service="procedimentos.index"
      name="requisicao"
      ref="requisicaoconsulta"
      :consulta="true"
      :id_anamnese="value.id_anamnese"
      :id_paciente="id_paciente"
      :id_unidade_operacao="( atendimento && atendimento.marcacao ) 
        ? atendimento.marcacao.id_unidade_operacao 
        : ( atendimento.avulso ? atendimento.avulso.id_unidade_operacao : null )"
      :atendimento="atendimento"
      @refresh="imprimir_requisicao"
    ></order-set>

    <!-- Consulta -->
    <order-set
      title="Solicitação de Cirurgia"
      v-model="requisicao"
      service="procedimentos.index"
      name="requisicao"
      ref="requisicaocirurgia"
      :cirurgia="true"
      :id_anamnese="value.id_anamnese"
      :id_paciente="id_paciente"
      :atendimento="atendimento"
      @refresh="imprimir_requisicao"
    ></order-set>

    <!-- Atestado -->
    <form-atestado ref="atestado" :id_anamnese="value.id_anamnese" @refresh="$emit('refresh')" />

    <!-- Envio de Arquivo -->
    <az-file-upload
      ref="upload"
      :multiple="true"
      @refresh="$emit('refresh')"
      :arquivos="value.arquivos"
      :parms="{ model_type: 'anamnese', model_id: value.id_anamnese }"
    ></az-file-upload>

    <!-- Documentos -->
    <documento ref="documento"
      :block_doc_titulo="block_doc_titulo"
      :anamnese="{
        ...value,
        ...(
            ( atendimento_procedimento && atendimento_procedimento.laudo )
              ? atendimento_procedimento.laudo
              : {}
        )
      }"
      :atendimento="atendimento"
      :podeassinar="true"
      :id_paciente="atendimento.id_paciente"
      @refresh="imprimir_documento"
      @remover="removerDoc"
      @solicitar="solicitar_procedimento_do_doc"
      :infopaciente="infopaciente"
      :id_procedimento="marcacao ? marcacao.id_procedimento : null" />

    <hr />
    <p class="text-center text-muted">Fim</p>

    <!-- Relatórios -->
    <RelatorioReceita
      v-if="value.receita"
      :paciente="atendimento.paciente"
      :medico="atendimento.medico"
      ref="relatorioReceita"
    />

    <RelatorioPrescricao
      v-if="value.requisicao"
      :paciente="atendimento.paciente"
      :medico="atendimento.medico"
      ref="relatorioPrescricao"
    />

    <relatorio-orientacao
      ref="relatorioOrientacao"
      v-if="value.documentos"
      medico2="atendimento.medico"
      :medico="atendimento.medico"
      :paciente="atendimento.paciente" />

    <impressao-anamnese ref="impressaoAnamnese" />

    <memed
        ref="memedRef"
        :atendimento="atendimento"
        :id_anamnese="value.id_anamnese"
        @refresh="$emit('refresh')" />

    <importar-externo ref="exame" />

    <suspender-prescricoes ref="prescrativas" />

  </div>
</template>

<script>
import _ from "lodash";
import $ from "jquery";
import * as moment from "moment";
import AzFileUpload from "../../util/AzFileUpload.vue";
import OrderSet from "./OrderSet.vue";
import OrderSetView from "./OrderSetView.vue";
import AtestadoView from './AtestadoView.vue';
import Formulario from "./Formulario.vue";
import Documento from "./Documento.vue";
import FormAtestado from "../../shared/atestado/FormAtestado.vue";
import ImpressaoAnamnese from "./ImpressaoAnamnese.vue";
import RelatorioReceita from "../../relatorios/consultorio/RelatorioReceita.vue";
import RelatorioPrescricao from "../../relatorios/consultorio/RelatorioPrescricao.vue";
import RelatorioOrientacao from "../../relatorios/consultorio/RelatorioOrientacao.vue";
import Memed from "./Memed.vue";
import ImportarExterno from './ImportarExterno.vue';
import VerArquivosRolagem from './VerArquivosRolagem.vue';
import SuspenderPrescricoes from './SuspenderPrescricoes.vue';
import UrlEstudoPacs from "../pacs/UrlEstudoPacs.vue";

export default {
  data() {
    return {
      historico_receita: null,
      novo_medicamento: null,
      novo_procedimento: null,
      receita: { items: [], in_ciclos: null },
      requisicao: { items: [] },
      saved: true,
      timeout: null,
      hasMounted: false,
      mode: "atendimento",
      medicoReport: null,
      canceltoken: null,
      search_doc: "",
      ver_anexos_preview: false, 
    };
  },

  watch: {
    value: {
      handler: function(newValue) {
        if (!this.hasMounted) {
          return;
        }

        this.saved = false;

        if ( this.canceltoken ) {
            this.canceltoken.cancel('#BC#');
        }

        if (this.timeout) clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          let query = {
            q: [
              {
                name: "pep.anamnese_salvar",
                id: "anamnese_salvar",
                parms: { ...newValue }
              }
            ]
          };

          this.canceltoken = this.axios.CancelToken.source();

          this.axios.post(
              "/aql?a=anamnese.salvar",
              query,
              {
                  cancelToken: this.canceltoken.token
              }
            ).then(res => {
            if (
              res && res.data &&
              res.data.anamnese_salvar &&
              res.data.anamnese_salvar.status == 200 &&
              res.data.anamnese_salvar.data == "OK"
            ) {
              this.saved = true;
              // clearTimeout(this.timeout);
            }
          });
        }, 2000);
      },

      deep: true,
      immediate: true
    }
  },

  props: [
    "value",
    "validate",
    "id_paciente",
    "tipo_consulta",
    "atendimento_procedimento",
    "marcacao",
    "atendimento",
    "tem_prescricao",
    "tem_infusao",
    "tem_solic_consulta",
    "ehlaudo",
    "block_doc_titulo", 
    "prescricao_suspender", 
    "receita_medicamento_buscar", 
    "integracao_ymunity", 
  ],

  components: {
    AzFileUpload,
    OrderSet,
    OrderSetView,
    Formulario,
    Documento,
    FormAtestado,
    ImpressaoAnamnese,
    RelatorioReceita,
    RelatorioPrescricao,
    RelatorioOrientacao,
    AtestadoView,
    Memed,
    ImportarExterno,
    VerArquivosRolagem,
    SuspenderPrescricoes,
    UrlEstudoPacs
  },

  computed: {
    lista_documentos: function () {
      return this.value.documentos.filter(item => !this.search_doc
        || ( item.modelo_documento && item.modelo_documento.js_classes && item.modelo_documento.js_classes.find(tag => tag == this.search_doc) ) );
    },

    infopaciente: function () {
      return {
        sexo: _.get(this.atendimento, 'paciente.cadastro.ch_sexo'),
        idade_anos: this.calculateAgeYear(
          _.get(this.atendimento, 'paciente.cadastro.dt_nascimento'),
          _.get(this.atendimento, 'dt_inicio')
        ),
        idade_meses: this.calculateAge(
          _.get(this.atendimento, 'paciente.cadastro.dt_nascimento'),
          _.get(this.atendimento, 'dt_inicio')
        ),
      };
    },

    title_requisicao: function () {
      return ( this.requisicao && this.requisicao.fl_cirurgia )
        ? 'Solicitação de Cirurgia'
        : ( ( this.requisicao && this.requisicao.fl_consulta )
          ? 'Encaminhamento de Consulta'
          : 'Requisição de Exames/Procedimentos' );
    },

    pode_alterar: function() {
      return this.atendimento &&
        this.atendimento.pode_alterar_prontuario &&
        !this.atendimento.pode_alterar_prontuario.pode
        ? false
        : true;
    },

    /*
    pode_assinar: function () {
      return this.atendimento &&
        this.atendimento.medico.tem_certificado &&
        this.atendimento.medico.id_pessoa == this.$store.state.user.id_pessoa;
    },
    */

    pode_assinar: function () { 
      let id_medico;
      let medico = this.$store.state.user.medico;

      if ( !medico && this.atendimento ) { 
        if ( this.$store.state.user.delegantes_medicos.find(deleg => deleg.delegante.id_pessoa == this.atendimento.medico.id_pessoa) ) { 
          id_medico = this.atendimento.medico.id_pessoa;
        }
      } else { 
        id_medico = this.$store.state.user.id_pessoa;
      }

      return this.atendimento && this.atendimento.medico.id_pessoa == id_medico; // && this.atendimento.medico.tem_certificado 
    },

    pode_abrir_pacs: function() {
        return ( this.atendimento_procedimento && this.atendimento_procedimento.st_pacs == 'OK' ) || window.redir == 'andreprincipe';
    },

    tags_doc: function () {

      return ( !this.value || !this.value.documentos ) ? []
        :  _.uniq(
            this.value.documentos.filter(item => item.modelo_documento && item.modelo_documento.js_classes)
              .flatMap(item => item.modelo_documento.js_classes)
              .sort()
          );

    },

  },

  methods: {
    abrir_ymunity () { 
        this.$util.loadItem(this, { 
            service: 'medicos',
            func: 'ymunity_get_url',
            parms: { 
                id_unidade_operacao: ( this.atendimento && this.atendimento.marcacao ) ? this.atendimento.marcacao.id_unidade_operacao : null,
            }
        })
        .then(res => { 
            if ( res && res.url ) { 
                window.open(res.url, '_blank');
            } else { 
                this.$toast.add({
                    severity: 'warning',
                    summary: 'yMunity',
                    detail: 'Não foi possível obter a URL do yMunity.',
                    life: 5000
                });
            }
        });
    },

    prescricoes_ativas () {
        if ( !this.prescricao_suspender ) { 
            return;
        }

        this.$refs.prescrativas.abrir(this.id_paciente);
    },

    compartilhar_order_set (order) { 
        this.$emit('compartilhar', order);
    },

    solicitar_procedimento_do_doc (documento) { 
      if ( documento.modelo_documento && documento.modelo_documento.fl_solic_proc && documento.modelo_documento.id_procedimento_solic ) { 
        this.abrir('requisicao', null, false, null, documento.modelo_documento);
      }
    },

    salvado() { 
      return this.ehlaudo || this.saved;
    },

    salvar(valor = null) { 
      if ( !valor )
        valor = this.value;

      let query = {
        q: [
          {
            name: "pep.anamnese_salvar",
            id: "anamnese_salvar",
            parms: { ...valor }
          }
        ]
      };

      this.canceltoken = this.axios.CancelToken.source();

      this.axios.post(
          "/aql?a=anamnese.salvar",
          query,
          {
              cancelToken: this.canceltoken.token
          }
        ).then(res => {
        if (
          res && res.data &&
          res.data.anamnese_salvar &&
          res.data.anamnese_salvar.status == 200 &&
          res.data.anamnese_salvar.data == "OK"
        ) {
          this.saved = true;
        }
      });
    },

    calculateAgeYear (dateString, otherDate) {

        var today = moment(otherDate);
        var birthDate = moment(dateString);
        var age = Math.floor(today.diff(birthDate, 'years', true));
        return age;

    },

    calculateAge (dateString, otherDate) {

        var today = moment(otherDate);
        var birthDate = moment(dateString);
        var age = today.diff(birthDate, 'months', true);
        return age;

        // Código antigo que estava dando diferença de 1 mês no cálculo
        // var today = new Date(otherDate);
        // var birthDate = new Date(dateString);
        // var age = today.getFullYear() - birthDate.getFullYear();
        // var m = today.getMonth() - birthDate.getMonth();
        // age = age * 12 + m;

        // if ( today.getDay() < birthDate.getDay() ) {
        //     age--;
        //     age = age + ( ( birthDate.getDay() - today.getDay() ) / 30 );
        // } else {
        //     age = age + ( ( 30 + birthDate.getDay() - today.getDay() ) / 30 );
        // }

        // return age;
    },

    abrir_import () {
      console.log(this.$refs);
      this.$refs.exame.abrir();
    },

    memed() {
      this.$refs.memedRef.show();
    },

    cliente() {
      return window.redir;
    },

    lista_complementos (item) {
      return item.receita.concat(item.requisicao)
        .concat(item.documentos)
        .concat(item.atestados);
    },

    toggle_hide_all(value) {
      let lista = this.lista_complementos(value);

        let acao = lista.find(item => item && !item.hide) ? true : false;

        lista.forEach(item => {
            if ( item ) {
                item.hide = acao;
            }
        });

        this.$forceUpdate();
    },

    abrir_fila (fila) {
      this.$parent.$refs.filaproc.encaminhar(this.atendimento, fila);
    },

    historico_lateral() {
      this.$parent.abrir_historico_lateral();
    },

    abrir_galeria_imagens() {
      this.$parent.abrir_galeria_imagens();
    },

    resultados(lateral = false) {
      this.$parent.resultados(lateral);
    },

    cancelar_assinatura () {
      if ( !confirm('Confirmar cancelar a assinatura do documento?') )
        return;

      this.$util.atualizar(this, {
        service: 'pep',
        func: 'cancelar_assinatura',
        dados: {
          id_anamnese: this.value.id_anamnese,
        },
        toast: true,
        callback: () => {
          this.$emit('refresh');
        }
      })
    },

    lista_fixa_barra(ap) {
      return ap.modelo_prontuario_opcional.concat(ap.modelo_prontuario_opcional_lista.map(item => item.modelo_prontuario));
    },

    eh_consulta (atdp) {
      return atdp.procedimento && (
        atdp.procedimento.id_classe_procedimento == 1
        || atdp.procedimento.st_codigo_cbhpm == '10101039'
      );
    },

    removerDoc (id_documento_atendimento) {

      let doc = this.value.documentos.find(item => item.id_documento_atendimento = id_documento_atendimento);

      if( doc ) {
        doc.removendo = true;
        this.$forceUpdate();
      }

    },

    cancelar(item) {
      if ( !confirm("Confirma cancelar esse registro assinado?") )
        return;

      this.$util.atualizar(this, {
        service: 'pep',
        func: 'item_remover',
        dados: {
          model_type: item.model.type,
          model_id: item.model.id,
        },
        callback: () => {
          this.$emit('refresh');
        }
      });

    },

    assinar (order) {
      this.$emit('assinar', order);
    },

    refresh(dados, imprimirFunc = null) {
      this.$emit("refresh");

      if (imprimirFunc && dados) {
        this.$nextTick(() => {
          imprimirFunc(dados ? dados : null);
        });
      }
    },

    definirModelo(id_modelo_prontuario) {
      if (this.atendimento_procedimento.medico_procedimento_unidade) {
        let dados = {
          ...this.atendimento_procedimento.medico_procedimento_unidade
        };
        dados.id_modelo_prontuario = id_modelo_prontuario;

        this.$util.atualizar(this, {
          service: "medico_procedimento_unidades",
          dados: dados,
          toast: true
        });
      }
    },

    atualizarModelo(modelo) {
      this.value.id_modelo_prontuario = modelo.id_modelo_prontuario;
      this.value.st_layout_impressao = modelo.st_layout_impressao;

      if ( this.value.modelo_prontuario ) {
        this.value.modelo_prontuario.st_form_tamanho_padrao = modelo.st_form_tamanho_padrao;
        this.value.modelo_prontuario.fl_compact = modelo.fl_compact;
        this.value.modelo_prontuario.fl_espaco_reduzido = modelo.fl_espaco_reduzido;
      }
    },

    historico_flat(hist) {
      return _.flatMap(hist.atendimento_procedimentos, item => {
        return _.flatMap(item.anamnese.receita, item => {
          return item.receita_medicamentos;
        });
      });
    },

    excluirItem(lista, index) {
      lista.splice(index, 1);
    },

    tag_anamnese(tag) {
      return this.value.tag_anamneses.find(item => {
        return item.id_tag == tag.id_tag;
      });
    },

    nova_prescricao() {
      this.historico_receita = null;

      let query = {
        q: [
          {
            name: "pep.historico_receita",
            id: "historico_receita",
            parms: { id: this.id_paciente }
          }
        ]
      };

      this.axios.post("/aql", query).then(res => {
        if (res.data.historico_receita.status == 200) {
          this.historico_receita = res.data.historico_receita.data;
        }
      });

      $("#prescricaoModal").modal("show");
    },

    nova_requisicao() {
      $("#requisicaoModal").modal("show");
    },

    novo_documento(form = null) {
      if (form) {
        this.$refs.documento.novoFormulario(form);
      } else {
        alert("em desenvolvimento...");
      }
    },

    incluir_hist_medicamento(hist) {
      let items = this.historico_flat(hist);

      items.forEach(item => {
        this.receita.receita_medicamentos.push({
          id_receita: null,
          id_receita_medicamento: null,
          medicamento: item.medicamento,
          st_posologia: item.st_posologia
        });
      });
    },

    incluir_medicamento() {
      this.receita.receita_medicamentos.push({
        id_receita: null,
        id_receita_medicamento: null,
        medicamento: this.novo_medicamento,
        st_posologia: this.novo_medicamento.st_posologia
      });

      this.$nextTick(() => {
        this.novo_medicamento = null;
      });
    },

    abrir(ref, item = null, prescricao_cirurgia = false, tipo = null, info_solic = null) {
      if ( ref == 'infusao' ) {
        alert ('Em desenvolvimento...');
        return;
      }

      if (!this.pode_alterar) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Edição não disponível.",
          life: 3000
        });
        return;
      }

      let lista = null;

      if (item) {
        this[ref] = _.cloneDeep(item);
      } else {

        let peso = null;
        let altura = null;
        let creatinina = null;

        if ( this.atendimento && this.atendimento.marcacao && this.atendimento.marcacao.doc_pre_atends && ref == 'receita' && prescricao_cirurgia ) { 
          let valores = this.atendimento.marcacao.doc_pre_atends.flatMap(item => item.js_conteudo ? item.js_conteudo : []);

          if ( valores ) { 

            valores = this.$util.valores(valores);

            peso = _.get(valores.find(item => item.id == 'peso' && item.value), 'value');
            altura = _.get(valores.find(item => item.id == 'altura' && item.value), 'value');
            creatinina = _.get(valores.find(item => item.id == 'creatinina' && item.value), 'value');

            peso = this.$util.tratar_valor(peso);
            altura = this.$util.tratar_valor(altura);
            creatinina = this.$util.tratar_valor(creatinina);

          }
        }

        item = {
          id_anamnese: this.value.id_anamnese,
          fl_exibir_data: this.$util.getCookie(ref + '-exibir-data') == 'N' ? false : true,
          dt_referencia: this.$util.hoje(),
          st_tipo_receita: "",
          items: [],
          fl_prescricao: ( ref == 'requisicao' ? false : prescricao_cirurgia ),
          fl_cirurgia: ( ref == 'receita' ? false : prescricao_cirurgia ),
          fl_consulta: ( ref == 'requisicao' && tipo == 'C' ? true : false ),
          id_cid: this.atendimento.id_cid,
          cid: this.atendimento.cid,
          id_cid_2: null,
          cid2: null,
          id_cid_3: null,
          cid3: null,
          materiais: [],
          in_ciclos: null,
          id_procedimento_protocolo: "", 
          ver_peso: false, 
          in_peso: peso, 
          in_altura: altura, 
          dc_cretinina: creatinina,
          plano: null, 
        };

        if ( info_solic ) { 
          if ( info_solic.id_cid_solic && info_solic.cid_solic ) { 
            item.id_cid = info_solic.id_cid_solic;
            item.cid = info_solic.cid_solic;
          }

          if ( info_solic.id_procedimento_solic && info_solic.procedimento_solic ) { 

            let teste = this.value.requisicao.find(req => req.items && req.items.find(item => item.id_procedimento == info_solic.id_procedimento_solic));

            if ( teste ) { 
              return;
            } 

            lista = { 
              items: [
                { 
                  id_procedimento: info_solic.id_procedimento_solic,
                  item: info_solic.procedimento_solic
                }
              ]
            };

          }

        }

        this.receita = {
          id_anamnese: this.value.id_anamnese,
          st_tipo_receita: "",
          items: [],
          fl_prescricao: prescricao_cirurgia,
          in_ciclos: null,
        };

        this.requisicao = {
          id_anamnese: this.value.id_anamnese,
          fl_cirurgia: prescricao_cirurgia,
          fl_consulta: item.fl_consulta,
          id_plano: null, 
          plano: null, 
          items: [],
          materiais: [],
        };
      }

      if ( ref == 'requisicao' && ( prescricao_cirurgia || item.fl_cirurgia ) ) {
        ref = 'requisicaocirurgia';
      } else if ( ref == 'requisicao' && ( item.fl_consulta ) ) {
        ref = 'requisicaoconsulta';
      }

      this.$refs[ref].abrir(item, lista);
    },

    enviar_arquivo() {
      this.$refs.upload.abrir();
    },

    abrir_atestado(atestado = null) {
      if (!this.pode_alterar) {
        this.$toast.add({
          severity: "error",
          summary: "Atenção",
          detail: "Edição não disponível.",
          life: 3000
        });
        return;
      }

      let objetoModal = {
        ...this.atendimento,
        atendimento: this.atendimento
      };

      if(_.get(this.atendimento, 'marcacao.dt_checkin')) {
        objetoModal['dt_checkin'] = this.atendimento.marcacao.dt_checkin;
      }

      this.$refs.atestado.abrirModalAtestado(objetoModal, atestado, false, true);
    },

    imprimir_atestado(atestado) {
      this.$util.print_preview('imprimir/atestado/' + atestado.id_atestado, true, { noass: 1 }, true);
    },

    imprimirAnamnese(id_anamnese) {
        if ( this.value.doc_certificado ) { 
            this.$util.print_preview('imprimir/doc_certificado/anamnese/' + id_anamnese, true, { noass: 1 }, true);      
        } else { 
            this.$util.print_preview('imprimir/anamnese/' + id_anamnese, true, { noass: 1 }, true);
        }
    },

    imprimir_receita(dados) {
      this.$emit("refresh");

      if ( !dados )
        return;

      //receitas

      this.$util.print_preview('imprimir/receita/' + dados.id_receita, true, { noass: 1 }, true);
    },
    imprimir_requisicao(dados) {
      this.$emit("refresh");

      if ( !dados )
        return;

      this.$util.print_preview('imprimir/requisicao/' + dados.id_requisicao, true, { modelo: dados.modelo, noass: 1 }, true);
    },
    imprimir_documento(doc) {
      this.$emit("refresh");

      if ( doc ) {
        this.$util.print_preview('imprimir/documento/' + doc.id_documento_atendimento, true, { noass: 1 }, true);
      }
    },
  
    // Imagens

    is_image (arquivo) { 
        return arquivo.st_tipo_arquivo == 'png' || arquivo.st_tipo_arquivo == 'jpg' || arquivo.st_tipo_arquivo == 'jpeg';
    },

    is_office (arquivo) { 
        return arquivo.st_tipo_arquivo == 'docx' || arquivo.st_tipo_arquivo == 'xlsx' || arquivo.st_tipo_arquivo == 'pptx';
    },

    link_office(arquivo) { 
        return "https://view.officeapps.live.com/op/view.aspx?src=" 
            + encodeURIComponent(arquivo.temporary_url)
            + '&wdEmbedCode=0&wdPrint=0';
    },
  },

  mounted() {
    this.hasMounted = true;
  },

  updated() {
    $('[data-toggle="tooltip"]').tooltip();
  }
};
</script>

<style scoped>
.ajusteform { 
  line-height: 1 !important;
  margin-bottom: 0 !important;
}

.encurtar p {
  margin-bottom: 0px !important;
}
</style>